import { RootRoute } from "./root-route";
import { IndexRoute } from "./routes/index";
import { SourcesRoute } from "./routes/sources";
import { KallorRoute } from "./routes/kallor";
import { AboutRoute } from "./routes/om";
import { ApiRoute } from "./routes/api";
import { FaqRoute } from "./routes/faq";
import { KommunRoute } from "./routes/kommun";

export { RootRoute };
export const routeTree = RootRoute.addChildren([
  IndexRoute,
  SourcesRoute,
  KallorRoute,
  AboutRoute,
  ApiRoute,
  FaqRoute,
  KommunRoute,
]);
